import React from "react";
import { UserAccountRole } from "../../domain/user/account/UserAccountRole";
import { Paths } from "../../Paths";
import { useAuthUser } from "../hooks/auth/useAuthUser";
import { Navigate } from "react-router-dom";

export function RoleRouter() {
    const user = useAuthUser();

    switch (user.role) {
        case UserAccountRole.ADMINISTRATOR: {
            return <Navigate to={Paths.admin} replace/>;
        }
        case UserAccountRole.OPERATOR: {
            return <Navigate to={Paths.careRecipient} replace/>;
        }
        case UserAccountRole.CLIENT: {
            return <Navigate to={Paths.careRecipient} replace/>;
        }
        default: {
            return null;
        }
    }
}
